import React from "react";
import { Modal, Button } from "react-bootstrap";
import { areasApi as api } from "../api/Areas.api";
import ActivityLoader from "activity/componenets/ActivityLoader";

const DeleteConfirmationModal = ({ show, onHide, area }) => {
  const [deleteArea, { isLoading }] = api.useDeleteAreaMutation();

  const handleDelete = async () => {
    await deleteArea(area.id);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete area <strong>{area.name}</strong>?
      </Modal.Body>
      <Modal.Footer>
        {isLoading ? (
          <ActivityLoader />
        ) : (
          <>
            <Button variant="secondary" className="btn-flat" onClick={onHide}>
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              variant="danger"
              className="btn-flat"
            >
              Delete
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
